import { CommonModule } from '@angular/common';
import { Component, Inject, Input } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { AIQuizLimitExceededType } from '@edtech-ui/constants/quiz-limit-type.enum';

@Component({
	selector: 'app-quiz-total-ai-question-limit-dialog',
	standalone: true,
	imports: [CommonModule],
	templateUrl: './quiz-total-ai-question-limit-dialog.component.html',
	styleUrl: './quiz-total-ai-question-limit-dialog.component.scss'
})
export class QuizTotalAiQuestionLimitDialogComponent {

	@Input() progress: number = 0;
	aiQuizLimitExceededType = AIQuizLimitExceededType;
	classroomId: number = 1;

	constructor(
		public dialogRef: MatDialogRef<QuizTotalAiQuestionLimitDialogComponent>,
		@Inject(MAT_DIALOG_DATA) public data: {
			type: AIQuizLimitExceededType, message?: string,	},
		private router: Router,
	) { }


	goToUpgradePage() {
		this.router.navigate(['/teacher-dashboard/upgrade-plan']);
		this.dialogRef.close();
	}

	addManually() {
		this.dialogRef.close({ goToManual: true });
	}
	
	close() {
		this.dialogRef.close();
	}
}
